import {ALLOWED_IMAGE_TYPES, CREATIVE_MAX_IMAGE_SIZE_BYTES} from '../../../common/constants/assetUpload'
import {loadImageAsDataUrl} from '../../../common/utils/spriteUpload'
import {IconLoadError} from '../iconGenerator/loadIconFile'

const loadImageFromUrl = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new IconLoadError('failed'))
    img.src = url
  })

/** Like the icon loader but with the larger creative-assets size limit. */
export const loadCreativeImageFile = async (file: File): Promise<HTMLImageElement> => {
  if (!ALLOWED_IMAGE_TYPES.has(file.type)) throw new IconLoadError('invalidType')
  if (file.size > CREATIVE_MAX_IMAGE_SIZE_BYTES) throw new IconLoadError('tooLarge')
  return loadImageFromUrl(await loadImageAsDataUrl(file))
}
